import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ILookup, IProject } from 'src/app/shared/models/app.model';
import { ProjectListService } from '../services/project-list.service';

@Component({
    selector: 'app-project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.less'],
    standalone: false
})

export class ProjectListComponent implements OnInit {

  projectList: IProject[] = [];
  lookup: ILookup = {
    status: [],
    studios: [],
    productionTypes: [],
    corporations: [],
    distributors: [],
    creativeExecutives: [],
		category: [],
  };
  projectHeaderStatus: any = [
    {
      id: 1,
      label: 'Active',
    },
    {
      id: 2,
      label: 'In-Active',
    },
  ];
  projectHeaderStatusValue = 1;
  constructor(
    private projectListService: ProjectListService,
    private router: Router
  ) {
    this.cloneIconClick = this.cloneIconClick.bind(this);
    this.projectListService.getLookup().subscribe((resp) => {
      this.lookup = resp;
    });
    this.projectListService.getProjectList().subscribe((resp) => {
      this.projectList = resp.projects;
    });
  }
  ngOnInit(): void {}
  projectHeaderStatusValueChange = (e: any) => {
    this.projectHeaderStatusValue = e.value;
  };
  calculateFilterExpression = (
    filterValue: any,
    selectedFilterOperation: any,
    target: any
  ) => {
    if (target === 'search' && typeof filterValue === 'string') {
      return [(this as any).dataField, 'contains', filterValue];
    }
    return function (data: any) {
      return (data.corporations || []).indexOf(filterValue) !== -1;
    };
  };
  cellTemplate = (container: any, options: any) => {
    const noBreakSpace = '\u00A0';
    const text = (options.value || [])
      .map((element: any) => options.column.lookup.calculateCellValue(element))
      .join(', ');
    container.textContent = text || noBreakSpace;
    container.title = text;
  };
  onTagBoxEditorValueChanged = (e: any, cellInfo: any) => {
    cellInfo.setValue(e.value);
  };
  calculateFilterExpression2 = (
    filterValue: any,
    selectedFilterOperation: any,
    target: any
  ) => {
    if (target === 'search' && typeof filterValue === 'string') {
      return [(this as any).dataField, 'contains', filterValue];
    }
    return function (data: any) {
      return (data.corporations || []).indexOf(filterValue) !== -1;
    };
  };
  cellTemplate2 = (container: any, options: any) => {
    const noBreakSpace = '\u00A0';
    const text = (options.value || [])
      .map((element: any) => options.column.lookup.calculateCellValue(element))
      .join(', ');
    container.textContent = text || noBreakSpace;
    container.title = text;
  };
  getStatus = (d: any): string => {
    let returnValue = '';
    returnValue = this.lookup.status.filter((stat) => stat.id == d.value)[0]
      ?.label;
    return returnValue;
  };
  cloneIconClick(e: any) {
    const clonedItem = { ...e.row.data, id: this.getMaxID() };

    this.projectList.splice(e.row.rowIndex, 0, clonedItem);
    e.event.preventDefault();
  }
  getMaxID = (): number => {
    let returnValue = 0;
    this.projectList.forEach((rowData) => {
      if (rowData.id > returnValue) {
        returnValue = rowData.id;
      }
    });
    return returnValue + 1;
  };
  contextMenuTarget: any = '#contextLinkId145401';
  contextItems = [
    {
      text: 'Project Details',
      routeLink: '/production-budget',
    },
    {
      text: 'Weekly Status',
      routeLink: '/production-budget',
    },
    {
      text: 'Deal Manage',
      routeLink: '/production-budget',
    },
    {
      text: 'Budget',
      routeLink: '/production-budget',
    },
    {
      text: 'Project Variance',
      routeLink: '/production-budget',
    },
    {
      text: 'Music',
      routeLink: '/production-budget',
    },
    {
      text: 'Schedule and Locations',
      routeLink: '/production-budget',
    },
    {
      text: 'Post Production Schedules',
      routeLink: '/production-budget',
    },
    {
      text: 'Production Offices',
      routeLink: '/production-budget',
    },
    {
      text: 'Vendors',
      routeLink: '/production-budget',
    },
    {
      text: 'Corporations and Bank Accounts',
      routeLink: '/production-budget',
    },
  ];
  selectedTitle: any;
  onMouseOverContext = (data: any) => {
    if (data.id) {
      this.contextMenuTarget = '#contextLinkId' + data.id;
      this.selectedTitle = data;
    }
  };
  contextItemClick = (e: any) => {
    if (!e.itemData.items && this.selectedTitle) {
      this.router.navigate([
        e.itemData.routeLink + '/' + this.selectedTitle.id,
      ]);
    }
  };
}
